import React from 'react';
import { useLocation } from 'react-router-dom';
import LogoutButton from './LogoutButton';
import SidebarBankHeader from './components/SidebarBankHeader';
import Section from './components/Section';
import Item from './components/Item';
import { FiHome, FiFileText, FiVideo, FiRadio, FiRefreshCw, FiClipboard } from 'react-icons/fi';
import { Accordion } from './components/Accordion';

export default function RegionalSidebar() {
    const location = useLocation();
    
    return (
        <div className="flex h-screen flex-col bg-white text-gray-900 dark:bg-[#0f172a] dark:text-white">
            <SidebarBankHeader title="Regional Head" />
            <nav className="flex-1 overflow-y-auto p-2 text-sm">
                <Accordion defaultOpenId="requests">
                    <Section id="main" title="Main Menu" alwaysOpen>
                        <Item icon={FiHome} label="Dashboard" to="/dashboard" active={location.pathname === '/dashboard'} />
                    </Section>
                    <Section id="protocols" title="Protocols" subtitle="Manage Protocol Operations">
                        <Item icon={FiClipboard} label="Protocols" to="/protocols" active={location.pathname === '/protocols'} />
                    </Section>
                    <Section id="requests" title="Requests" subtitle="Manage Requests">
                        <Item icon={FiClipboard} label="Request Summary" to="/request-summary" active={location.pathname === '/request-summary'} />
                        <Item icon={FiFileText} label="Request Form" to="/request-form" active={location.pathname === '/request-form'} />
                        <Item icon={FiFileText} label="Travelling Approval" to="/travelling-approval" active={location.pathname === '/travelling-approval'} />
                        <Item icon={FiVideo} label="CCTV" to="/cctv" active={location.pathname === '/cctv'} />
                        <Item icon={FiRadio} label="BAMS" to="/bams" active={location.pathname === '/bams'} />
                        <Item icon={FiRefreshCw} label="Change of Vendor" to="/change-of-vendor" active={location.pathname === '/change-of-vendor'} />
                    </Section>
                </Accordion>
            </nav>
            <div className="shrink-0">
                <LogoutButton />
            </div>
        </div>
    );
}


